// extracted by mini-css-extract-plugin
export default {"headers":"scoreboard_headers__Eu91c","scoreHeader":"scoreboard_scoreHeader__BLYEG","container":"scoreboard_container__xGqx0"};